import { createSlice } from "@reduxjs/toolkit";

const emiratesAndRegionsSlice = createSlice({
    name: 'markets',
    initialState: {
        selectedEmirates: [],
        selectedRegion: [],
    },
    reducers: {
        setSelectedEmirates: (state, action) => {
            state.selectedEmirates = action.payload;
        },
        setSelectedRegion: (state, action) => {
            state.selectedRegion = action.payload;
        },
        clearSelectedEmirates: (state) => {
            state.selectedEmirates = [];
        },
        clearSelectedRegion: (state) => {
            state.selectedRegion = [];
        }
    }
});

export const { setSelectedEmirates,setSelectedRegion, clearSelectedEmirates,clearSelectedRegion } = emiratesAndRegionsSlice.actions;
export default emiratesAndRegionsSlice.reducer;